(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const filter = document.querySelector('[data-brand-filter]');
    if (!filter) return;

    const search = filter.querySelector('[data-brand-search]');
    const pills = filter.querySelectorAll('[data-letter]');
    const noResults = filter.querySelector('[data-no-results]');
    const grid = filter.closest('.brand-grid__inner').querySelector('.brand-grid__list');
    const items = grid.querySelectorAll('.brand-grid__item');

    let activeLetter = 'all';

    function applyFilter() {
      const query = search.value.trim().toLowerCase();
      let visible = 0;

      items.forEach(function (item) {
        const name = item.dataset.brandName || '';
        const matchesLetter = activeLetter === 'all' || name.charAt(0) === activeLetter;
        const matchesSearch = !query || name.includes(query);
        const show = matchesLetter && matchesSearch;

        item.hidden = !show;
        if (show) visible++;
      });

      noResults.hidden = visible > 0;
    }

    search.addEventListener('input', applyFilter);

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('brand-filter__pill--active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('brand-filter__pill--active');
        pill.setAttribute('aria-selected', 'true');
        activeLetter = pill.dataset.letter;
        applyFilter();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
